;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { EXPLORE_TOPIC_CONFIGS } from '../constants';

export default function shouldRenderContentNav(path: string) {
  // Homepage should render the content nav
  if (path === '/') {
    return true;
  }

  // Explore pages should render content nav only if the topic slug is valid
  if (path.startsWith('/explore/')) {
    const maybeValidTopicSlug = path.replace('/explore/', '').replace(/\/$/, '');

    // render the content nav if it's a real topic slug or if it's the passport landing page
    return Object.keys(EXPLORE_TOPIC_CONFIGS).includes(maybeValidTopicSlug) || maybeValidTopicSlug === 'passport';
  }

  return false;
}
